import {AvaliacaoService} from './../modal-avaliacao/avaliacao.service';
import {TipoApoioLogistico} from './../shared/Util';
import {JasperService} from './../shared/jasper.service';
import * as QRCode from 'qrcode';
import swal from 'sweetalert2';

import {Component, ElementRef, HostListener, OnInit, ViewChild} from "@angular/core";

import {BreakpointObserver} from '@angular/cdk/layout';
import {GridsterComponent, GridsterConfig, GridsterItem, GridsterItemComponent} from "angular-gridster2";
import {BoxListTruckService} from "../box-list-truck/box-list-truck.service";
import {ControlStatusService, State} from '../shared/control-status.service';
import {GraphicService} from "../shared/graphic.service";
import {DashboardService} from "./dashboard.service";

import {isNullOrUndefined} from "is-what";
import {PopupConfigService} from "../popup-config/popup-config.service";
import {Util} from "../shared/Util";

import { CardSemComunicacaoDashboardComponent } from "../card-sem-comunicacao-dashboard/card-sem-comunicacao-dashboard.component";
import { RoteirosOcorrenciasDashboardCardComponent } from "../roteiros-ocorrencias-dashboard-card/roteiros-ocorrencias-dashboard-card.component";
import { PainelMensagensService } from '../shared/painel-mensagens.service';
import { RouteService } from '../shared/route.service';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { JsonReturn, ObjectParam } from '../shared/interface/generic-interface';
import { NgIf, NgClass, NgFor, DatePipe } from '@angular/common';
import { ModalAvaliacaoComponent } from '../modal-avaliacao/modal-avaliacao.component';
import { FormsModule } from '@angular/forms';
import { DadosEntregasComponent } from '../dados-entregas/dados-entregas.component';
import { StatusDasEntregasComponent } from '../status-das-entregas/status-das-entregas.component';
import { RelatoriosDashboardCardComponent } from '../relatorios-dashboard-card/relatorios-dashboard-card.component';
import { CardUltimasEntregasComponent } from '../card-ultimas-entregas/card-ultimas-entregas.component';
import { VisitasComponent } from '../visitas/visitas.component';
import { AlertasCardComponent } from '../alertas-card/alertas-card.component';
import { RoteiroCardComponent } from '../roteiro-card/roteiro-card.component';
import { PopupConfigComponent } from '../popup-config/popup-config.component';
import { PopupTokensComponent } from '../popup-tokens/popup-tokens.component';
import { MapComponent } from '../map/map.component';
import { MainHeaderTruckComponent } from '../main-header-truck/main-header-truck.component';
import { BoxInfoLeftComponent } from '../box-info-left/box-info-left.component';
import { PopupDistPercorridaComponent } from '../popup-dist-percorrida/popup-dist-percorrida.component';
import { PopupRelatoriosComponent } from '../popup-relatorios/popup-relatorios.component';
import { PopupJasperComponent } from '../popup-jasper/popup-jasper.component';
import { ModalFormuilarioRelatoriosComponent } from '../relatorios-dashboard-card/modal-formuilario-relatorios/modal-formuilario-relatorios.component';
import { PopupAvisosNovidadesComponent } from '../popup-avisos-novidades/popup-avisos-novidades.component';
import { PopupOcorrenciaPedagioComponent } from '../popup-ocorrencia-pedagio/popup-ocorrencia-pedagio.component';
import { PopupPrecosPracaPedagioComponent } from '../popup-precos-praca-pedagio/popup-precos-praca-pedagio.component';
import { PopupDadosRecebedorComponent } from '../popup-dados-recebedor/popup-dados-recebedor.component';
import { AlertaNotificacaoComponent } from '../alerta-notificacao/alerta-notificacao.component';
import { FilterPipe } from '../../pipes/pesquisa/pesquisa.pipe';
import { CookieService } from 'ngx-cookie-service';
import { PopupTemperaturaRoteiroComponent } from '../popup-temperatura-roteiro/popup-temperatura-roteiro.component';
import { CardCrossdockingComponent } from '../card-crossdocking/card-crossdocking.component';

declare var bootbox: any
declare let $: any
let controller: any;

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.css"],
    standalone: true,
    imports: [NgIf, NgClass, ModalAvaliacaoComponent, NgFor, FormsModule, DadosEntregasComponent, GridsterComponent, GridsterItemComponent, RoteirosOcorrenciasDashboardCardComponent, StatusDasEntregasComponent, CardSemComunicacaoDashboardComponent, RelatoriosDashboardCardComponent, CardUltimasEntregasComponent, VisitasComponent, AlertasCardComponent, RoteiroCardComponent, PopupConfigComponent, PopupTokensComponent, MapComponent, MainHeaderTruckComponent, BoxInfoLeftComponent, PopupDistPercorridaComponent, PopupRelatoriosComponent, PopupJasperComponent, ModalFormuilarioRelatoriosComponent, PopupAvisosNovidadesComponent, PopupOcorrenciaPedagioComponent, PopupPrecosPracaPedagioComponent, PopupDadosRecebedorComponent, AlertaNotificacaoComponent, DatePipe, FilterPipe, CardCrossdockingComponent, PopupTemperaturaRoteiroComponent]
})
export class DashboardComponent implements OnInit {
  options: GridsterConfig;
  itensOption: GridsterItem;
  dashboard: Array<GridsterItem>;
  public state = State;
  expand_class: boolean = true;
  canSee: boolean = false;
  numeroRoteiroBusca = '';
  model = new Date();
  modalNumber: number = 0;
  arrayTitulo: any = [];
  arrayBody: any = [];
  valorInput: any = '';
  dataInicio: any = '';
  dataFim: any = '';
  dateChange: boolean = false;
  filtroParametro: string = 'roteiro';
  placeholderBusca: string = 'Buscar';
  pesquisaAcoes: any;
  cdEmp: any;
  razaoSocial: string
  qtdLiberada = 0;
  qtdUsada = 0;
  qtdSimu = 0;
  avisoConsumo = true;
  meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
  mesConsumo = '';
  exibeOpcaoPainelAntigo = false;
  mostrarRecursoToken = false;
  isMobile: boolean = false;

  checkIsMobile(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
    const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isSmallScreen = window.innerWidth <= 992;
    return isSmallScreen || isMobileUserAgent;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile = this.checkIsMobile();
  }

  auxFiltraPorEmpresa: boolean = false
  roteirosPorEmpresa: any = []
  mostraNotAlerta = false;

  urlJasper: string = ''
  listaApoiologistico: any[] = [TipoApoioLogistico.Todos];
  pontoApoioSelecionado: String = TipoApoioLogistico.Todos;

  dataAtual = new Date();
  comunicacaoComDataAtual = false;
  roteirosComunicaoFiltro = []
  //Propriedade Lista as empresas e filiais
  listaEmpresas = []

  cardVisitas = {
    posicao: {cols: 12, rows: 8, x: 0, y: 0},
    mostrar: true
  };

  cardClientes = {
    posicao: {cols: 6, rows: 6, x: 0, y: 8},
    mostrar: true
  };
  cardRoteiros = {
    posicao: {cols: 6, rows: 6, x: 6, y: 8},
    mostrar: true
  };

  cardSemComunicacao = {
    posicao: {cols: 6, rows: 6, x: 0, y: 14},
    mostrar: true
  };

  cardUltimasEntregas = {
    posicao: {cols: 6, rows: 6, x: 6, y: 14},
    mostrar: true
  };

  cardRelatorios = {
    posicao: {cols: 6, rows: 6, x: 0, y: 32},
    mostrar: false
  };


  cardAjusteLayout = {
    posicao: {cols: 1, rows: 3, x: 0, y: 26},
    mostrar: true
  };
  carregando = {
    clientes: false,
    ocorrencias: false,
    roteiros: false,
    semComunicacao: false
  };

  cardAlertas = {
    posicao: {cols: 6, rows: 6, x: 0, y: 20},
    mostrar: true
  };

  cardCrossdocking = {
    posicao: {cols: 6, rows: 6, x: 6, y: 20},
    mostrar: true
  };

  dashboardResult: any;

  totais = {
    totalClientes: 0,
    totalClientesAtendidos: 0,
    totalClientesNaoAtendidos: 0,
    totalClientesAnalise: 0,
    totalClientesNaoVisitados: 0
  };

  totaisOcorrencias = {
    emAberto: 0,
    emAnalise: 0,
    finalizadas: 0
  };

  totaisSituacoes = {
    totalEntregues: 0,
    iniciou: 0,
    pausou: 0,
    semCoordenadas: 0,
    saiu: 0,
    emAberto: 0,
    finalizou: 0,
  }

  roteiros: any = [];
  roteirosSemComunicacao: any = [];
  roteiroModal: any;
  roteirosAtivos: number = 0;
  roteirosPausa: number = 0;
  ocorrencias: any = [];
  relatorios: any = [];
  urlDownload = '';

  allRoteiros = [];

  //Aux para testes
  auxOcorrencias: any = [];
  auxTotaisOcorrencias = {
    emAberto: 0,
    emAnalise: 0,
    finalizadas: 0
  };;


  //filtro card visitas
  filtroVisitaStatus = [
    {titulo: 'Finalizados', check: true, situaoRoteiroID: 5},
    {titulo: 'Não iniciados', check: true, situaoRoteiroID: 1},
    {titulo: 'Pausados', check: true, situaoRoteiroID: 3},
    {titulo: 'Em andamento', check: true, situaoRoteiroID: 2}
  ]
  textoFiltroBusca = '';
  filtroVisitaAtivoIDs: Array<number> = [];

  today: number = Date.now();

  primeiraCarga: boolean = true;
  loading: boolean = false;
  versaoAtualApp: String;
  versaoAtualTransp: String;
  roteirosVersaoDesatualizada = [];
  versaoTranspDesatualizada = [];
  contemAvisosNovidades = false
  dashboardResultTotal = [];
  filtroAtivo: boolean = false;
  roteirosOriginal: any[];
  idSituacaoFiltro: number | null = null;
  exibePilulaAvaliacao = false;
  ordenarSelecionado: string = localStorage.getItem('ordenacao') || 'roteiro';

  @ViewChild('modal') modal: ElementRef;

  @ViewChild('contentModal') contentModal: ElementRef;

  resultadoMovimentacaoDia: any[] = [];


  @ViewChild(CardSemComunicacaoDashboardComponent) cardSemComunicao: CardSemComunicacaoDashboardComponent
  @ViewChild(RoteirosOcorrenciasDashboardCardComponent) roteiroOcorrencia: RoteirosOcorrenciasDashboardCardComponent

  loaderFiltro: boolean = false;

  constructor(public dashboardService: DashboardService, public controlStatus: ControlStatusService,
    private boxListTruckService: BoxListTruckService, private graphicService: GraphicService,
    private util: Util, public popupConfigService: PopupConfigService,
    public jasperService: JasperService,
    private painelMensagensService: PainelMensagensService,
    private routeService: RouteService,
    public boxInfoRouterService: BoxInfoRouterService,
    public avaliacaoService: AvaliacaoService,
    private cookieService: CookieService,
    private breakpointObserver: BreakpointObserver
  ) {
    controller = this;

    this.options = {
      itemInitCallback: DashboardComponent.itemInit,
      itemChangeCallback: DashboardComponent.itemChange,
      itemResizeCallback: DashboardComponent.itemResize,
      itemRemovedCallback: this.itemRemove,
      keepFixedHeightInMobile: true,
      mobileBreakpoint: 640,
      draggable: {
        enabled: true,
        ignoreContent: false,
        ignoreContentClass: 'no-drag'
      },
      gridType: 'verticalFixed',
      maxCols: 12,
      pushItems: false,
      swap: true,
      fixedRowHeight: 50,

    };

  }
  ultimasEntregas = [];

  async ngOnInit() {
    this.isMobile = this.checkIsMobile();
    this.breakpointObserver.observe(['(max-width: 992px)']).subscribe(result => {
      this.isMobile = this.checkIsMobile();
    });
    this.iniciaFiltroVisita()
    const response: [] = await this.popupConfigService.getConfiguracoesGerais();
    let contemTempoAtualizacao = response.some((config: any) => config.Nome == 'TempoDeAtualizacaoRadar')
    if (contemTempoAtualizacao) {
      let configuracao: any = response.find((config: any) => config.Nome == 'TempoDeAtualizacaoRadar')
      let valor = Number(configuracao.Valor);
      if (valor > 0) {
        setInterval(() => {this.refreshTela();}, 60000 * valor);
      }
    } else {
      setInterval(() => {this.refreshTela();}, 30000 * 60);
    }

    this.numeroRoteiroBusca = '';
    this.atualizaPosicoes();
    await this.getConsumoDt();
    this.roteiros = new Array();
    this.roteirosPorEmpresa = new Array();
    this.roteirosSemComunicacao = new Array();
    this.dashboardResult = new Array();
    await this.getUltimasEntregas();


    //Carrega itens na tela e força loading inicial
    this.loading = true;
    this.primeiraCarga = await this.refreshTela();

    await this.dashboardService.getEmpresasJasper().then(async empresa => {
      let cnpj = empresa.find((emp) => emp.Ativo).CGC
      await this.jasperService.getDadosDBeServidor(cnpj)
    })


    this.contemAvisosNovidades = (await this.painelMensagensService.dados()).length > 0;
    this.avisoVersaoDesativda()
    this.verificaDesatToken();
    this.verificaExisteAvaliacao();
    let ordenacaoSalva = localStorage.getItem('ordenacao');
    if (ordenacaoSalva) {
      this.onOrdenar(ordenacaoSalva);
    }
  }

  changedOptions() {
    this.options.api.optionsChanged();
  }

  // INICIO MODAL GPS
  async getListRouterTruck() {
    let objParam = this.dashboardService.criarObjParamRoteiro();
    await this.boxListTruckService.getListRouterTruck(objParam);
  }

  onScroll(event: WheelEvent): void {
    const element = event.currentTarget as HTMLElement;
    element.scrollLeft += event.deltaY;
    event.preventDefault();
  }


  onOrdenar(tipo: string): void {
    localStorage.setItem('ordenacao', tipo);

    switch (tipo) {
      case 'roteiro':
        this.ordenarPorRoteiro();
        break;
      case 'situacao':
        this.ordenarPorSituacao();
        break;
      case 'entregas':
        this.ordenarPorEntregas();
        break;
    }
  }

  ordenarPorRoteiro(): void {
    this.dashboardResult.sort((a, b) => a.NumeroRoteiro - b.NumeroRoteiro);
  }

  ordenarPorSituacao(): void {
    this.dashboardResult.sort((a, b) => a.IdRoteiroSituacao - b.IdRoteiroSituacao);
  }

  ordenarPorEntregas(): void {
    this.dashboardResult.sort((a, b) => b.totalCliente - a.totalCliente); // maior para menor
  }

  async getListRouterTruckPorId(pedido) {
    const responsePorId = await this.boxListTruckService.getListRouterTruckPorId(pedido);
    this.boxListTruckService.listTruckService = isNullOrUndefined(responsePorId) ? null : responsePorId[0];
    return isNullOrUndefined(responsePorId) ? null : responsePorId[0];
  }

  tipoFiltro(parametro) {
    this.filtroParametro = parametro;
  }

  async buscarRoteiro() {
    //abrir loading
    this.controlStatus.controlarLoading(true);
    this.controlStatus.msgErroBusca = '';

    if (this.numeroRoteiroBusca && !isNullOrUndefined(this.numeroRoteiroBusca) || this.dashboardService.nuRotAtualizaCoordenadas) {
      try {
        if (!this.numeroRoteiroBusca) {
          this.numeroRoteiroBusca = this.dashboardService.nuRotAtualizaCoordenadas.toString()
        }
        await this.visualizadorDeRoteiros(this.numeroRoteiroBusca, true);
        if (!isNullOrUndefined(this.roteiroModal)) {
          $("#modalPrincipal").modal('show');
        } else {
          this.voltarTelaInicial();
          this.alertaRoteiro(this.controlStatus.msgErroBusca);
        }
      } catch (error) {
        this.controlStatus.erroRelatorio = true;
        this.controlStatus.carregandoRelatorios = true;
        this.controlStatus.avisoRelatorio = 'Ocorreu um erro ao recuperar o roteiro.';
      }
    } else {
      this.voltarTelaInicial();
      this.alertaRoteiro(this.controlStatus.msgErroBusca);
    }

    this.numeroRoteiroBusca = '';
    this.controlStatus.controlarLoading(false);
  }

  alertaRoteiro(msg) {
    bootbox.alert(msg == '' ? "Roteiro não encontrado!" : msg);
  }

  async visualizadorDeRoteiros(numeroBusca, busca) {
    this.graphicService.mostraConfiguracaoRoteiro = false;
    let roteiro = 0
    if (Array.isArray(numeroBusca)) {
      roteiro = numeroBusca[0]
      if (numeroBusca[1] != 0) {
        this.graphicService.numeroClienteFoco = numeroBusca[1];
        this.graphicService.coordenadaCenter = null
      } else {
        this.graphicService.coordenadaCenter = {latitude: numeroBusca[2].latitude, longitude: numeroBusca[2].longitude}
      }
    } else {
      roteiro = numeroBusca;
      this.graphicService.coordenadaCenter = null
      this.graphicService.numeroClienteFoco = 0;
    }
    let pedido = false;
    if (this.filtroParametro == 'pedido' && busca) {
      pedido = true;
    }

    this.controlStatus.carregando = true;
    this.roteiroModal = null;

    this.boxListTruckService.roteiroSelecionado = roteiro;

    this.roteiroModal = await this.getListRouterTruckPorId(pedido);

    if (this.roteiroModal) {
      let situacaoResult = await this.dashboardService.getSituacaoRoteiro(this.roteiroModal.roteiro);
      this.roteiroModal.situacao = situacaoResult[0] ? situacaoResult[0].situacao : null;
    }

    this.controlStatus.currentState = State.visualizadorDeRoteiros;
    this.controlStatus.carregouMapa = true;

    await this.graphicService.redimensionaMapa();
    this.tipoFiltro('roteiro')
  }

  async voltarTelaInicial() {
    this.graphicService.limparRota();
    this.graphicService.limparPontosMapa();
    this.controlStatus.carregando = false;
    this.controlStatus.currentState = State.visaoGeral;
    this.controlStatus.carregouMapa = false;
  }
  // FIM MODAL GPS

  async contaClientesPorTipo() {
    this.dashboardResult = await this.getTotalClientes();

    for (let i = 0; i < this.dashboardResult.length; i++) {
      let infoRota: any = JSON.parse(this.dashboardResult[i].InfoRota) ?? false;
      let consideraEndPed = infoRota.ConsideraEndPed ? true : false;

      if (consideraEndPed) {
        let resultado = await this.getTotalRoteiro(this.dashboardResult[i].NumeroRoteiro)
        this.dashboardResult[i].totalClienteEmAnalise = resultado.totalClienteEmAnalise
        this.dashboardResult[i].totalClienteEntregue = resultado.totalClienteEntregue
        this.dashboardResult[i].totalClienteNaoAtendidos = resultado.totalClienteNaoAtendidos
        this.dashboardResult[i].totalClienteNaoVisitado = resultado.totalClienteNaoVisitado
        this.dashboardResult[i].totalClienteRecusado = resultado.totalClienteRecusado
      }

      this.dashboardResult[i].totalCliente = this.dashboardResult[i].totalClienteEmAnalise +
        this.dashboardResult[i].totalClienteEntregue +
        this.dashboardResult[i].totalClienteNaoAtendidos +
        this.dashboardResult[i].totalClienteNaoVisitado +
        this.dashboardResult[i].totalClienteRecusado
    }


    this.dashboardResultTotal = Array.from(this.dashboardResult)
    let consultaVersaoBd = await this.getVersaoAtualAplicativo();
    //let consultaVersaoTransp = await this.getVersaoTranspAplicativo();
    //this.versaoAtualTransp = consultaVersaoTransp.response.find((versao) => versao.ativa)
    this.versaoAtualTransp = '0.0.0'//consultaVersaoTransp['versao']; todo REMOVER TUDO DA TRANSPORTADORA!!!!

    const versaoAtiva = consultaVersaoBd?.response?.find((versao) => versao.ativa);
    this.versaoAtualApp = versaoAtiva?.versao || '1.0.0';
    this.urlDownload = versaoAtiva?.urlBucket || `https://rotaplan.paineltarget.com.br/RotaPlanV2/APK/${this.versaoAtualApp}/ROTAPLAN.apk`;
    this.roteirosVersaoDesatualizada = this.dashboardResult.filter((roteiro) => (roteiro.VersaoApp != this.versaoAtualApp && roteiro.VersaoApp != null && !roteiro.RoteiroTransportadora))
    this.versaoTranspDesatualizada = this.dashboardResult.filter((roteiro) => roteiro.VersaoApp < this.versaoAtualTransp && roteiro.RoteiroTransportadora)


    if (this.dashboardResult && this.dashboardResult.length > 0) {
      //Limpa os campos
      this.limparTotais();

      //Cria totais dos clientes.
      this.atualizaTotais();
    }

    this.limparTotais();
    this.atualizaTotais();
  }


  async contaRoteirosPorSituacao() {
    this.limparTotaisSituacao();
    if (this.dashboardResult && this.dashboardResult.length > 0) {
      //Limpa os campos
      this.limparTotaisSituacao();

      let arr = this.dashboardResult;
      this.totaisSituacoes.totalEntregues = arr.filter((situacao) => situacao.totalCliente == situacao.totalClienteEntregue + situacao.totalClienteRecusado).length

      for (let i = 0; i < arr.length; i++) {
        switch (arr[i].situacao) {
          case "Iniciou": this.totaisSituacoes.iniciou += 1; break; //iniciou
          case "Pausou": this.totaisSituacoes.pausou += 1; break; //pausou
          case "Saiu": this.totaisSituacoes.saiu += 1; break; //saiu
          case "-": this.totaisSituacoes.emAberto += 1; break; //em aberto
          case "Finalizado": this.totaisSituacoes.finalizou += 1; break;
        }
      }
    }

    // contabiliza roteiros do tipo crossdocking (TipoRoteiroID === 2)
    if (this.roteiros && this.roteiros.length > 0) {
      const crossdockings = this.roteiros.filter((r: any) => r.TipoRoteiroID === 2);
      for (const roteiro of crossdockings) {
        switch (roteiro.IdRoteiroSituacao) {
          case 1: this.totaisSituacoes.emAberto += 1; break;  // Não iniciado
          case 2: this.totaisSituacoes.iniciou += 1; break;   // Em rota
          case 3: this.totaisSituacoes.pausou += 1; break;    // Pausado
          case 4: this.totaisSituacoes.saiu += 1; break;      // Sem sinal
          case 5: this.totaisSituacoes.finalizou += 1; break; // Finalizado
        }
      }
    }
  }


  filtrarPorSituacao(idSituacao: number) {
    // verifica se o filtro atual é o mesmo que o filtro anterior
    if (this.filtroAtivo && this.idSituacaoFiltro === idSituacao) {
      // Restaurar os roteiros originais
      this.roteiros = this.roteirosOriginal.slice();
      this.filtroAtivo = false;
      this.idSituacaoFiltro = null; // reseta o id do filtro
    } else {
      // aplica novo filtro
      if (!this.filtroAtivo) {
        this.roteirosOriginal = this.roteiros.slice();
        this.filtroAtivo = true;
      }
      this.roteiros = this.roteirosOriginal.filter((situacao) => situacao.IdRoteiroSituacao === idSituacao);
      this.idSituacaoFiltro = idSituacao; // armazena o id do filtro atual
    }
  }

  async contaOcorrenciasPorTipo() {
    if (!this.auxFiltraPorEmpresa) {
      this.ocorrencias = await this.getTotalOcorrencias();
      if (this.ocorrencias) {
        this.limparTotaisOcorrencias();

        this.totaisOcorrencias.emAberto = this.ocorrencias.reduce((preVal, elem) => preVal + elem.emAberto, 0);
        this.totaisOcorrencias.emAnalise = this.ocorrencias.reduce((preVal, elem) => preVal + elem.emAnalise, 0);
        this.totaisOcorrencias.finalizadas = this.ocorrencias.reduce((preVal, elem) => preVal + elem.finalizadas, 0);
      }
      this.carregando.ocorrencias = true;
    }
  }

  async montarRoteiroCard() {
    if (this.auxFiltraPorEmpresa == true) {

      if (this.allRoteiros.length == 0) {
        this.roteiros = await this.getRoteiros();
        this.allRoteiros = Array.from(this.roteiros)
      }

      let roteirosFiltrado = this.roteiroFiltrados();
      this.roteiros = this.allRoteiros.filter((roteiro) => roteirosFiltrado.includes(roteiro.roteiro))


    } else {
      if (this.allRoteiros.length == 0) {
        this.roteiros = await this.getRoteiros();
        this.allRoteiros = Array.from(this.roteiros)
      } else {
        this.roteiros = Array.from(this.allRoteiros)
      }

    }
    if (this.roteiros) {
      this.contaRoteirosPorSituacao();

      //Adiciona atributo dataDiff
      this.roteirosSemComunicacao = this.roteiros.filter(roteiro => {if (!this.verificaPorcentagemMaxima(roteiro)) {return roteiro} }).map(a => Object.assign({}, a));
      this.roteirosSemComunicacao.filter(roteiro => {
        roteiro.dataDiff = this.retornaDataDiffPorNumero(roteiro.roteiro);
      })
      this.roteirosSemComunicacao = this.roteirosSemComunicacao.filter(roteiro => {
        return roteiro.IdRoteiroSituacao !== 1
      })

      this.roteirosComunicaoFiltro = this.roteirosSemComunicacao;

      this.carregando.roteiros = true;
      this.carregando.semComunicacao = true;
    }
    this.comunicacaoComDataAtual = !this.comunicacaoComDataAtual;
  }

  verificaPorcentagemMaxima(roteiro) {
    let porcentagem = ((roteiro.realizadas * 100) / (roteiro.QtdeEntregas == 0 ? 1 : roteiro.QtdeEntregas)).toFixed(0);
    return parseInt(porcentagem) == 100 ? true : false;
  }

  limparTotais() {
    this.totais.totalClientes = 0;
    this.totais.totalClientesAtendidos = 0;
    this.totais.totalClientesNaoAtendidos = 0;
    this.totais.totalClientesAnalise = 0;
    this.totais.totalClientesNaoVisitados = 0;
  }

  limparTotaisSituacao() {
    this.totaisSituacoes.iniciou = 0;
    this.totaisSituacoes.pausou = 0;
    this.totaisSituacoes.saiu = 0;
    this.totaisSituacoes.semCoordenadas = 0;
    this.totaisSituacoes.totalEntregues = 0;
    this.totaisSituacoes.emAberto = 0;
    this.totaisSituacoes.finalizou = 0;
  }

  limparTotaisOcorrencias() {
    this.totaisOcorrencias = {
      emAberto: 0,
      emAnalise: 0,
      finalizadas: 0
    };
  }

  retornaDataDiffPorNumero(numeroRoteiro) {
    let result = this.dashboardResult.filter(dados => {if (dados.NumeroRoteiro == numeroRoteiro) return dados})[0];
    if (!isNullOrUndefined(result)) {
      return result.dataDiff;
    }
    return 0;
  }

  //     === Configurações de cards ===
  // Funções para logar as NOVAS caracteristicas dos itens ao mudar o tamanho ou mudar a posição no dashboard

  static itemInit(item, itemComponent) {


  }

  static itemChange(item, itemComponent) {
    controller.salvarPosicoes();
  }
  static itemResize(item, itemComponent) {
  }

  itemRemove() {
    controller.salvarPosicoes();
  }

  expandRoteiros() {
    this.expand_class = !this.expand_class;
  }

  removeCardClientes() {
    this.cardClientes.mostrar = !this.cardClientes.mostrar;
    this.salvarPosicoes();
  }

  removeCardRoteiros() {
    this.cardRoteiros.mostrar = !this.cardRoteiros.mostrar;
    this.salvarPosicoes();
  }

  removeCardRelatorios() {
    this.cardRelatorios.mostrar = !this.cardRelatorios.mostrar;
    this.salvarPosicoes();
  }

  removeCardSemComunicacao() {
    this.cardSemComunicacao.mostrar = !this.cardSemComunicacao.mostrar;
    this.salvarPosicoes();
  }

  removeUltimasEntregas() {
    this.cardUltimasEntregas.mostrar = !this.cardUltimasEntregas.mostrar;
    this.salvarPosicoes();
  }

  removeAlertas() {
    this.cardAlertas.mostrar = !this.cardAlertas.mostrar;
    this.salvarPosicoes();
  }
  removeCardCrossdocking() {
    this.cardCrossdocking.mostrar = !this.cardCrossdocking.mostrar;
    this.salvarPosicoes();
  }

  removeCardVisitas() {
    this.cardVisitas.mostrar = !this.cardVisitas.mostrar;
    this.salvarPosicoes();
  }

  salvarPosicoes() {
    //Adicionar as variáveis dos cards para salvar
    localStorage.setItem('posicoes', JSON.stringify({
      cardClientes: this.cardClientes,
      cardRelatorios: this.cardRelatorios,
      cardRoteiros: this.cardRoteiros,
      cardSemComunicacao: this.cardSemComunicacao,
      cardUltimasEntregas: this.cardUltimasEntregas,
      cardAlertas: this.cardAlertas,
      cardVisitas: this.cardVisitas,
      cardAjusteLayout: this.cardAjusteLayout,
      cardCrossdocking: this.cardCrossdocking
    }));
  }

  atualizaPosicoes() {
    let posicoes = JSON.parse(localStorage.getItem('posicoes'));
    if (posicoes != null) {

      if (posicoes.cardVisitas == null || posicoes.cardCrossdocking == null) {
        this.resetarPosicoes()
        return;
      }

      if (posicoes.cardClientes != null) {
        this.cardClientes = posicoes.cardClientes;
      }

      if (posicoes.cardRoteiros != null) {
        this.cardRoteiros = posicoes.cardRoteiros;
      }

      if (posicoes.cardSemComunicacao != null) {
        this.cardSemComunicacao = posicoes.cardSemComunicacao;
      }
      if (posicoes.cardRelatorios != null) {
        this.cardRelatorios = posicoes.cardRelatorios;
      }

      if (posicoes.cardUltimasEntregas != null) {
        this.cardUltimasEntregas = posicoes.cardUltimasEntregas;
      }

      if (posicoes.cardAlertas != null) {
        this.cardAlertas = posicoes.cardAlertas;
      }

      if (posicoes.cardCrossdocking != null) {
        this.cardCrossdocking = posicoes.cardCrossdocking;
      }

      if (posicoes.cardVisitas != null) {
        this.cardVisitas = posicoes.cardVisitas;
      }

      if (posicoes.cardAjusteLayout != null) {
        this.cardAjusteLayout = posicoes.cardAjusteLayout;
      }

    }
  }
  //Fim - configurações de cards

  //Atualização automática

  filtroAlterado() {
    // Método que será chamado quando a data mudar
    this.refreshTela()
    this.loaderFiltro = true;
  }

  async refreshTela() {
    this.loading = true;
    this.allRoteiros = []
    await this.getEmpresa()
    await this.contaClientesPorTipo();
    await this.contaOcorrenciasPorTipo();
    await this.getUltimasEntregas();
    await this.montarRoteiroCard();
    this.today = Date.now();

    if (this.auxFiltraPorEmpresa) {
      this.getRoteirosPorEmpresa(this.cdEmp, this.razaoSocial)
    }

    // if(this.dashboardService.toggleMovimentacaoDia === false){
    //   this.resultadoMovimentacaoDia = this.resultadoMovimentacaoDia.filter(item => item.dataDiff === null); //adicionar a condicional ou para a data atual
    // }

    //Recarregar o chart.
    setTimeout(() => {
      this.loading = false;
      this.carregando.clientes = false;
      setTimeout(() => {
        this.carregando.clientes = true;
      }, 1);
    }, 100);

    this.loaderFiltro = false
    return false;
  }

  //Fim - Atualização automática

  //Inicio - Relatórios
  fecharLoading() {
    this.controlStatus.erroRelatorio = false;
    this.controlStatus.carregandoRelatorios = false;
  }


  //Fim - Relatórios

  //Inicio - Dropdown controller
  abreDropdown() {
    this.canSee = !this.canSee;
  }

  hide(e: any, config) {
    this.canSee = false;
    if (config) {
      this.controlStatus.popupConfig = true;
    }
  }
  //Fim - Dropdown controller

  //Chamadas de serviço
  async getRoteiros() {

    let objParam = this.dashboardService.criarObjParamRoteiro();

    let result = await this.dashboardService.getRoteiros(objParam);

    this.listaApoiologistico = [TipoApoioLogistico.Todos, ...result.filter((rot: any) => rot.clienteCrossdocking != null).map((rot: any) => rot.clienteCrossdocking)];
    this.pontoApoioSelecionado = TipoApoioLogistico.Todos;

    return result;
  }

  async getEmpresa() {

    let result = await this.dashboardService.getEmpresas()

    if (result) {
      result.filter(x => {
        let contemEmpresa = this.listaEmpresas.some((empresa) => empresa.cnpj == x.cnpj)

        if (!contemEmpresa) {
          this.listaEmpresas.push(
            {cdEmp: x.cdEmp, razaoSocial: x.razaoSocial, cnpj: x.cnpj, ativo: x.ativo, nomeFantasia: x.NomeFantazia},
          )
        }

      })
    } else {
      this.listaEmpresas = []
    }
    if (this.listaEmpresas.length > 0) {
      this.routeService.nomeCliente = this.listaEmpresas[0].razaoSocial
    }
  }


  //filtro de roteiros por empresa
  async getRoteirosPorEmpresa(cdEmp: number, razaoSocial?: string) {
    this.cdEmp = cdEmp
    this.razaoSocial = razaoSocial
    this.auxFiltraPorEmpresa = true;
    this.dashboardResult = this.dashboardResultTotal.filter((empresa) => empresa.cdEmp == cdEmp);
    this.atualizaDashboard();
    this.montarRoteiroCard();
    //simula click para atualizar empresa
    this.controlStatus.empresaSelecionada = cdEmp.toString()

  }

  async resetFiltroEmpresa() {
    this.cdEmp = undefined;
    this.auxFiltraPorEmpresa = false;
    this.dashboardResult = Array.from(this.dashboardResultTotal)
    this.atualizaDashboard();
    this.montarRoteiroCard();
    this.controlStatus.empresaSelecionada = null
  }

  atualizaDashboard() {
    this.atualizaTotais();

    let roteiros = this.roteiroFiltrados()
    this.cardSemComunicao.atualizaRoteiroSemComunicacao(roteiros);
    this.roteiroOcorrencia.atualizaOcorrencia(roteiros)
  }

  roteiroFiltrados(): any[] {
    let roteiros = [];
    this.dashboardResult.forEach(rot => {
      roteiros.push(rot.NumeroRoteiro);
    });
    return roteiros
  }

  atualizaTotais() {
    this.totais.totalClientes = this.dashboardResult.reduce((preVal, elem) => preVal + elem.totalCliente, 0);
    this.totais.totalClientesAtendidos = this.dashboardResult.reduce((preVal, elem) => preVal + elem.totalClienteEntregue, 0);
    this.totais.totalClientesNaoAtendidos = this.dashboardResult.reduce((preVal, elem) => preVal + elem.totalClienteNaoAtendidos + elem.totalClienteRecusado, 0);
    this.totais.totalClientesAnalise = this.dashboardResult.reduce((preVal, elem) => preVal + elem.totalClienteEmAnalise, 0);
    this.totais.totalClientesNaoVisitados = this.dashboardResult.reduce((preVal, elem) => preVal + elem.totalClienteNaoVisitado, 0);
  }

  async getTotalClientes() {
    let objParam = this.dashboardService.criarObjParamRoteiro();
    let result = await this.dashboardService.getTotalClientes(objParam);

    let listaCdEmp = [];
    if (result) {
      result.forEach(empresa => {
        if (empresa.cdEmp !== null) {
          listaCdEmp.push(empresa.cdEmp)
        }
      });

      let menorCdEmp = Math.min(...listaCdEmp);
      result.forEach(empresa => {
        if (empresa.cdEmp === null) {
          empresa.cdEmp = menorCdEmp;
        }
      });

      return result;
    } else {
      return null
    }




  }

  async getTotalRoteiro(numeroRoteiro) {
    let result = await this.dashboardService.getTotalRoteiro(numeroRoteiro);
    return result[0];
  }

  async getTotalOcorrencias() {
    let result = await this.dashboardService.getTotalOcorrencias();
    if (result) {
      return result;
    } else {
      return [];
    }
  }

  async getVersaoAtualAplicativo() {
    return await this.dashboardService.getVersaoAtualAplicativo();
  }

  async getVersaoTranspAplicativo() {
    return await this.dashboardService.getVersaoTranspAplicativo();
  }

  //Fim - chamadas de serviço

  formataCNPJ(cnpj: string) {
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }

  async getConsumoDt() {

    try {
      const resultado: JsonReturn = await this.dashboardService.getConsumoDt();

      this.qtdLiberada = resultado.response[1]['qtdLiberada']
      this.qtdUsada = resultado.response[1]['qtdUsada']
      this.qtdSimu = resultado.response[0]['IdRoteirizacoes']
      const data = new Date()
      this.mesConsumo = this.meses[data.getMonth()];
    } catch (e) {
      console.log("Erro ao consultar consumo")
    }

  }

  async getUltimasEntregas() {
    try {
      this.ultimasEntregas = await this.dashboardService.ultimasEntregas();
    } catch (e) {
      console.log("Erro ao consultar últimas entregas")
    }
  }

  visualizouAlerta() {
    this.avisoConsumo = false

  }

  avisoVersaoDesativda() {
    if (this.contemAvisosNovidades && !this.isMobile) {
      document.getElementById('btnAvisosNovidades').click();
    }
  }

  downloadApptransp() {
    document.getElementById('btnDownloadAppTransp').click();
  }

  async exibirQrCodeDownload() {
    const url = this.urlDownload || `https://rotaplan.paineltarget.com.br/RotaPlanV2/APK/${this.versaoAtualApp || '1.0.0'}/ROTAPLAN.apk`;
    try {
      const qrCodeUrl = await QRCode.toDataURL(url, { width: 250, margin: 2 });
      swal.fire({
        title: 'QR Code para Download',
        html: `
          <div class="d-flex flex-column align-items-center justify-content-center">
            <p class="mb-2 text-muted" style="font-size: 13px; word-break: break-all;">${url}</p>
            <img src="${qrCodeUrl}" alt="QR Code" style="max-width: 250px; height: auto; border: 1px solid #dee2e6; padding: 8px; border-radius: 8px;" />
          </div>
        `,
        showCloseButton: true,
        confirmButtonText: 'Fechar',
        confirmButtonColor: '#198754'
      });
    } catch (err) {
      console.error('Erro ao gerar QR Code:', err);
    }
  }

  async exibirQrCodeDownloadTransp() {
    const el = document.getElementById('btnDownloadAppTransp') as HTMLAnchorElement;
    const url = el?.href || this.urlDownload;
    if (!url) return;
    try {
      const qrCodeUrl = await QRCode.toDataURL(url, { width: 250, margin: 2 });
      swal.fire({
        title: 'QR Code App Transportadora',
        html: `
          <div class="d-flex flex-column align-items-center justify-content-center">
            <p class="mb-2 text-muted" style="font-size: 13px; word-break: break-all;">${url}</p>
            <img src="${qrCodeUrl}" alt="QR Code" style="max-width: 250px; height: auto; border: 1px solid #dee2e6; padding: 8px; border-radius: 8px;" />
          </div>
        `,
        showCloseButton: true,
        confirmButtonText: 'Fechar',
        confirmButtonColor: '#198754'
      });
    } catch (err) {
      console.error('Erro ao gerar QR Code:', err);
    }
  }

  resetarPosicoes() {
    localStorage.removeItem('posicoes');
    window.location.reload();
  }

  mostraAlertaNotic() {
    this.mostraNotAlerta = true;
  }

  alterarPainelAntigo() {
    let currentUrl = window.location.href;
    let newUrl = currentUrl.replace('RadarMotoristaNew', 'RadarMotorista',);
    window.location.href = newUrl;
  }

  verificaDesatToken() {
    const dataLimite = new Date('2024-10-01');
    const dataAtual = new Date();
    this.mostrarRecursoToken = dataLimite > dataAtual;
  }

  exibeModalAvaliacao() {
    this.dashboardService.exibirModalAvaliacao = !this.dashboardService.exibirModalAvaliacao;
  }

  showPilulaAvaliacao() {
    this.exibePilulaAvaliacao = !this.exibePilulaAvaliacao;
  }

  async verificaExisteAvaliacao() {
    try {
      const response = await this.avaliacaoService.getAvaliacaoPesquisa('INICIAL');

      this.exibePilulaAvaliacao = Array.isArray(response) && response.length > 0;

    } catch (error) {
      console.error('Erro ao verificar avaliação:', error);
    }
  }

  fecharModal() {
    this.dashboardService.exibirModalAvaliacao = false;
  }

  aberto = false;
  readonly keyFiltroVisitaCard = 'keyFiltroVisitaCard'

  mostrarEsconderFiltroVisita() {
    this.aberto = !this.aberto;
  }

  alteraFiltroVisita(salvaCache = true) {
    this.textoFiltroBusca = '';
    const filtroVisitaAtivo = this.filtroVisitaStatus.filter((opcao) => opcao.check)

    if (filtroVisitaAtivo.length == 1) {
      this.textoFiltroBusca = filtroVisitaAtivo[0].titulo;
    } else if (filtroVisitaAtivo.length > 1) {
      this.textoFiltroBusca = filtroVisitaAtivo[0].titulo;
      this.textoFiltroBusca += `, +${filtroVisitaAtivo.length - 1}`
    }

    if (salvaCache) this.cookieService.set(this.keyFiltroVisitaCard, JSON.stringify(this.filtroVisitaStatus))
    this.filtroVisitaAtivoIDs = this.filtroVisitaStatus.filter((opcao) => opcao.check).map((opc) => opc.situaoRoteiroID);
  }

  iniciaFiltroVisita() {
    const keyFiltroVisitaCard = this.cookieService.check(this.keyFiltroVisitaCard)
    if (keyFiltroVisitaCard) {
      this.filtroVisitaStatus = JSON.parse(this.cookieService.get(this.keyFiltroVisitaCard))
    }
    this.alteraFiltroVisita(false)
  }

  filtroApoiologistico($event) {
    this.pontoApoioSelecionado = $event;
  }
}
